import iRazPremiumNFTTestnet from './testnet/iRazPremiumNFT.sol/iRazPremiumNFT.json';
import iRazPremiumNFTMainnet from './mainnet/iRazPremiumNFT.sol/iRazPremiumNFT.json';

let iRazPremiumNFT = iRazPremiumNFTTestnet;
if(process.env.REACT_APP_NODE_ENV === "production"){
    iRazPremiumNFT = iRazPremiumNFTMainnet;
}

export default iRazPremiumNFT;